import { EditNotifications } from 'components-ref/organisms/settings-notifications-edit'
import { NotificationSettings } from 'pages/settings/NotificationSettings'

export const useSettingsRoutesNotifications = () => {
    return [
        {
            path: '/settings/notifications',
            Component: <NotificationSettings />,
            roles: ['model', 'fan'],
            exact: true
        },
        {
            path: [
                {
                    path: '/settings/notifications/push-notifications',
                    roles: ['model', 'fan'],
                    props: { type: '?push-notifications' }
                },
                {
                    path: '/settings/notifications/in-app-notifications',
                    roles: ['model', 'fan'],
                    props: { type: '?in-app-notifications' }
                },
                {
                    path: '/settings/notifications/toast-notifications',
                    roles: ['model', 'fan'],
                    props: { type: '?toast-notifications' }
                },
                {
                    path: '/settings/notifications/email-notifications',
                    roles: ['model', 'fan'],
                    props: { type: '?email-notifications' }
                },
                {
                    path: '/settings/notifications/sms-notifications',
                    roles: ['model', 'fan'],
                    props: { type: '?sms-notifications' }
                }
            ],
            Component: EditNotifications
        }
    ]
}
